module.exports = __webpack_public_path__ + "overview-a5b6df21/icon-fencing-32be84af829bbb24c95a1d2a25dffd37.png";